export default __webpack_public_path__ + "da153ccbb9b5de1eedfe092f2b8f7714.svg";